// @ts-nocheck
import {
  CFG,
  DEFAULT_BINDS,
  ITEMS,
  ITEM_ORDER,
  KEYBINDS,
  KEY_TO_SLOT,
  REPORT_CATEGORIES,
  REPORT_CAT_ORDER,
  RESERVED_KEYS,
  ROBES,
  SLOT_ORDER,
  LOADOUT,
  isBarFull,
  SHOP_CATEGORY_ORDER,
  SPELLS,
  SPELLS_IN_CATEGORY,
  shopCategoryLabel,
  slotOfSpell,
  SPELL_AVAIL,
  SPELL_ORDER,
  SPELL_SCHOOLS,
  START_LOADOUT,
  UPGRADE,
  eventKeyLabel,
  isLocalDev,
  isTeammate,
  itemCost,
  keyLabelForSlot,
  rebuildKeyToSlot,
  saveKeybinds,
  spellAvail,
  spellInfo,
  spellSfx,
  spellShopPurchasable,
  teamColor,
  PASSIVE_TREES,
  passiveOwned,
  passiveColPrereqNode,
  passivePrereqsMet,
  synergySpellUnlocked,
  synergySpellLockedIn,
  synergyPartnerMet,
  synergyUnlockLabel,
  synergyExclusiveBlocked,
  synergyExclusiveLabel,
  ownedSynergyOnSpell,
  synergiesHostedBy,
  synergyPartnerLitSpellIds,
  spellUnlockSp,
  spellCommitSp,
  passiveBuyCost,
  passiveBuyLabel,
  passiveBonusLines,
  passiveShopName,
  ownedSpellStats,
} from "../data";
import {
  TAU,
  bindTabPresenceUnload,
  clamp,
  len,
  lerp,
  rand,
  rgba,
  shade,
  shrinkState,
  tabPresenceId,
  track,
} from "../util";
import {
  SPRITE_BRIM,
  armTimedProg,
  assetURL,
  bossImageByOct,
  drawArmChargeAccent,
  drawArmRangeTelegraph,
  drawEntityGroundShadow,
  drawSpellSprite,
  drawStar,
  fireballSpriteFXEnabled,
  healPodFromWire,
  makeWizardSprite,
  octIndex,
  pveBossName,
  refreshSpellSpriteDevFields,
  spellCastPopLayer,
  spellCastPopPose,
  spellSpriteAnimFrame,
  spellSpriteDevVisible,
  spellSpriteDrawSz,
  spellSpritePhaseDrawSz,
  spellSpritePhaseLife,
  spellSpritePhaseOpt,
  spellSpritePhaseReady,
  spellSpritePhaseSpec,
  spellSpriteSpec,
  updateSpellSpriteDevPanelVisibility,
  warlockImage,
  warlockImageByOct,
} from "../sprites";
import {
  AUDIO_CREDITS,
  Sound,
} from "../audio";
import {
  spellIconInner,
  spellLabelHTML,
  synergyOrbInner,
} from "../spell-icons";
import {
  EMPTY_OPTS,
  Particle,
  Pillar,
  Player,
  Sigil,
  compact,
  recalcItems,
} from "../entities";
import {
  Net,
  Tip,
  angLerp,
  angleDiff,
  escapeHtml,
  fmtWhen,
  modeLabel,
  ordinal,
  setupUiButtonSounds,
  showConfirm,
  spellLabel,
  spellTipHTML,
  tipAttr,
} from "../net-ui";
import {
  lobbyInviteURL,
  parseLobbyInviteCode,
} from "../lobby";

import { Game } from "./game-base";
import {
  PICK_UNLOCK_BORDER_MS,
  PICK_UNLOCK_DOT_MS,
  PICK_UNLOCK_EDGE_MS,
  PICK_UNLOCK_START_MS,
  passiveNodeBorderRadius,
  startBorderReveal,
} from "./pick-unlock-anim";
import { clearSpellCatalogSearch, refreshSpellCatalogSearch } from "./spell-catalog-search";

function wrapShopOnBuy(onBuy) {
  return (kind, id) => {
    onBuy(kind, id);
    if (kind === "spell" || kind === "passive") clearSpellCatalogSearch();
  };
}

function clonePlanPassivesWire(wire) {
  const out = {};
  for (const [spellId, ids] of Object.entries(wire || {})) {
    out[spellId] = [...(ids || [])];
  }
  return out;
}

function planPassivesToWire(map) {
  const out = {};
  for (const [spellId, ids] of Object.entries(map || {})) {
    const list = [...(ids || [])];
    if (list.length) out[spellId] = list;
  }
  return out;
}

function planPassivesToSets(wire) {
  const out = {};
  for (const [spellId, ids] of Object.entries(wire || {})) {
    out[spellId] = new Set(ids || []);
  }
  return out;
}

function passiveHostSpell(passiveId) {
  for (const spellId of Object.keys(PASSIVE_TREES)) {
    if ((PASSIVE_TREES[spellId] || []).some(n => n.id === passiveId)) return spellId;
  }
  return null;
}

function planSpentWallets(planSpells, planPassivesWire) {
  let pp = 0;
  let sy = 0;
  for (const ids of Object.values(planPassivesWire || {})) {
    for (const pid of ids || []) {
      const spellId = passiveHostSpell(pid);
      const node = (PASSIVE_TREES[spellId] || []).find(n => n.id === pid);
      if (!node) continue;
      if (node.synergy) sy++;
      else pp++;
    }
  }
  return { sp: (planSpells || []).length, pp, sy };
}

function computePreviewLoadout(baseLoadout, planSpells) {
  const out = { ...(baseLoadout || {}) };
  for (const id of planSpells || []) {
    const slot = SLOT_ORDER.find(s => s !== "Space" && !out[s]);
    if (!slot) break;
    out[slot] = id;
  }
  return out;
}

function mergePlanPassives(basePassives, planPassivesWire) {
  const out = clonePassives(basePassives);
  for (const [spellId, ids] of Object.entries(planPassivesWire || {})) {
    if (!out[spellId]) out[spellId] = [];
    for (const pid of ids || []) {
      if (!out[spellId].includes(pid)) out[spellId].push(pid);
    }
  }
  return out;
}


function cascadePlanAfterSpellRemoved(planSets, spellId, basePassives) {
  delete planSets[spellId];
  for (const hostSpell of Object.keys(PASSIVE_TREES)) {
    for (const n of PASSIVE_TREES[hostSpell] || []) {
      if (n.synergy && n.requiresSpell === spellId && planSets[hostSpell]?.has(n.id)) {
        planSets[hostSpell].delete(n.id);
        if (!planSets[hostSpell].size) delete planSets[hostSpell];
      }
    }
  }
  cascadePlanPrereqs(planSets, basePassives);
}

function cascadePlanAfterPassiveRemoved(planSets, basePassives) {
  cascadePlanPrereqs(planSets, basePassives);
}

function cascadePlanPrereqs(planSets, basePassives) {
  let changed = true;
  while (changed) {
    changed = false;
    const merged = mergePlanPassives(basePassives, planPassivesToWire(
      Object.fromEntries(Object.entries(planSets).map(([k, v]) => [k, [...v]])),
    ));
    for (const hostSpell of Object.keys(planSets)) {
      for (const pid of [...planSets[hostSpell]]) {
        const node = (PASSIVE_TREES[hostSpell] || []).find(n => n.id === pid);
        if (!node || passivePrereqsMet(merged, hostSpell, node)) continue;
        planSets[hostSpell].delete(pid);
        changed = true;
      }
      if (planSets[hostSpell] && !planSets[hostSpell].size) delete planSets[hostSpell];
    }
  }
}

function optimisticShopPlanToggle(data, kind, id) {
  if (!data?.planning || data.shopLocked) return;
  const planSpells = [...(data.planSpells || [])];
  const planSets = planPassivesToSets(data.planPassives);
  const basePassives = data.passives || {};
  if (kind === "spell") {
    const idx = planSpells.indexOf(id);
    if (idx >= 0) {
      planSpells.splice(idx, 1);
      cascadePlanAfterSpellRemoved(planSets, id, basePassives);
    } else {
      planSpells.push(id);
    }
    data.planSpells = planSpells;
    data.planPassives = planPassivesToWire(planSets);
    return;
  }
  if (kind === "passive") {
    const spellId = passiveHostSpell(id);
    if (!spellId) return;
    if (!planSets[spellId]) planSets[spellId] = new Set();
    if (planSets[spellId].has(id)) {
      planSets[spellId].delete(id);
      if (!planSets[spellId].size) delete planSets[spellId];
      cascadePlanAfterPassiveRemoved(planSets, basePassives);
    } else {
      planSets[spellId].add(id);
    }
    data.planPassives = planPassivesToWire(planSets);
  }
}

function shopViewData(data) {
  if (!data?.planning) return data;
  const planSpells = data.planSpells || [];
  const planSpellSet = new Set(planSpells);
  const planPassivesWire = clonePlanPassivesWire(data.planPassives);
  const baseLoadout = data.loadout || {};
  const basePassives = data.passives || {};
  const spent = planSpentWallets(planSpells, planPassivesWire);
  const previewLoadout = computePreviewLoadout(baseLoadout, planSpells);
  const previewPassives = mergePlanPassives(basePassives, planPassivesWire);
  return {
    ...data,
    baseLoadout,
    basePassives,
    sp: (data.sp ?? 0) - spent.sp,
    pp: (data.pp ?? 0) - spent.pp,
    sy: (data.sy ?? 0) - spent.sy,
    loadout: previewLoadout,
    committed: data.previewCommitted || data.committed,
    passives: previewPassives,
    planSpells,
    planSpellSet,
    planPassives: planPassivesWire,
    shopLocked: !!data.shopLocked,
  };
}

function planSpellPending(data, id) {
  return !!data?.planSpellSet?.has(id);
}

function planPassivePending(data, spellId, passiveId) {
  return (data?.planPassives?.[spellId] || []).includes(passiveId);
}

function spellOwnedCommitted(data, id) {
  const base = data?.baseLoadout ?? data?.loadout ?? {};
  return Object.values(base).includes(id);
}

function spellPlannedOnly(data, id) {
  return planSpellPending(data, id) && !spellOwnedCommitted(data, id);
}

Game.prototype.applyShopPlanClick = function (kind, id) {
  if (!this._shopData) return;
  optimisticShopPlanToggle(this._shopData, kind, id);
  this.patchShopPlanUI();
};

/** Lightweight shop refresh while planning — avoids full grid rebuild + unlock anims. */
Game.prototype.patchShopPlanUI = function () {
  const shop = document.getElementById("shop");
  if (!shop || shop.classList.contains("hidden") || !this._shopData) return;
  const data = shopViewData(this._shopData);
  const goldEl = document.getElementById("shopGold");
  const spEl = document.getElementById("shopSp");
  const ppEl = document.getElementById("shopPp");
  const syEl = document.getElementById("shopSy");
  if (goldEl) goldEl.textContent = data.gold;
  if (spEl) spEl.textContent = data.sp ?? 0;
  if (ppEl) ppEl.textContent = data.pp ?? 0;
  if (syEl) syEl.textContent = data.sy ?? 0;
  const itemsHeld = ITEM_ORDER.reduce((n, id) => n + ((data.items && data.items[id]) || 0), 0);
  const itemCap = UPGRADE.maxItems || 6;
  const itemsFull = itemsHeld >= itemCap;
  const ownedEl = document.getElementById("shopOwned");
  if (ownedEl) {
    const itemsKey = ITEM_ORDER.map(id => (data.items && data.items[id]) || 0).join(",");
    if (this._shopItemsKey !== itemsKey) {
      this._shopItemsKey = itemsKey;
      const owned = ITEM_ORDER.filter(id => (data.items && data.items[id]) > 0);
      const label = `<span class="owned-label">Your items (${itemsHeld}/${itemCap})</span>`;
      if (!owned.length) {
        ownedEl.innerHTML = `<span class="owned-none">No items yet — buy in this tab (max ${itemCap})</span>`;
      } else {
        ownedEl.innerHTML = label + owned.map(id => {
          const it = ITEMS[id], n = data.items[id];
          return `<span class="owned-chip" ${tipAttr("item", id)} data-tip-count="${n}">${it.icon}<span class="owned-name">${escapeHtml(it.name)}</span>${n > 1 ? `<b>×${n}</b>` : ""}</span>`;
        }).join("");
      }
    }
  }
  const grid = document.getElementById("shopGrid");
  const onBuy = wrapShopOnBuy(this._shopOnBuy || (() => {}));
  patchShopItemsPanel(document.getElementById("shopItems"), data, onBuy, itemsFull);
  if (!grid?.querySelector(".category-block")) {
    if (this._shopOnBuy) this.renderShopUI(this._shopData, this._shopOnBuy);
    return;
  }
  const committed = data.committed || {};
  const passives = data.passives || {};
  const loadout = data.loadout || {};
  const barFull = isBarFull(loadout);
  patchShopSpellsGrid(this, grid, data, onBuy, {
    committed, passives, loadout, barFull, newPassivesBySpell: {},
  });
  grid._synergyHoverCtx = { loadout, committed, passives };
  refreshSpellCatalogSearch();
};

Game.prototype.refreshShopLoadout = function () {
    const shop = document.getElementById("shop");
    if (!shop || shop.classList.contains("hidden")) return;
    const h = this.human();
    if (!h) return;
    const grid = document.getElementById("shopGrid");
    if (!grid?.querySelector(".category-block")) return;
    const raw = this._shopData || {
      round: this.roundNumber,
      gold: h.gold,
      sp: h.skillPoints,
      pp: h.passivePoints,
      sy: h.synergyPoints,
      passives: h.passives || {},
      loadout: h.loadout || {},
      committed: h.committed || {},
      items: h.items || {},
    };
    const data = shopViewData(raw);
    const spEl = document.getElementById("shopSp");
    const ppEl = document.getElementById("shopPp");
    const syEl = document.getElementById("shopSy");
    if (spEl) spEl.textContent = data.sp ?? 0;
    if (ppEl) ppEl.textContent = data.pp ?? 0;
    if (syEl) syEl.textContent = data.sy ?? 0;
    const committed = data.committed;
    const passives = data.passives;
    const loadout = data.loadout;
    const barFull = isBarFull(loadout);
    const onBuy = wrapShopOnBuy(this._shopOnBuy || ((kind, id) => {
      if (this.net) this.net.send({ t: "buy", kind, id });
      Sound.ui();
    }));
    patchShopSpellsGrid(this, grid, data, onBuy, {
      committed, passives, loadout, barFull, newPassivesBySpell: {},
    });
    grid._synergyHoverCtx = { loadout, committed, passives };
    refreshSpellCatalogSearch();
  }

Game.prototype.renderShopUI = function (data, onBuy) {
    this.ensureShopDom();
    this._shopData = data;
    this._shopOnBuy = onBuy;
    const view = shopViewData(data);
    const buy = wrapShopOnBuy(onBuy);
    const lead = document.getElementById("shopSubLead");
    const tail = document.getElementById("shopSubTail");
    const roundEl = document.getElementById("shopRound");
    const goldEl = document.getElementById("shopGold");
    const spEl = document.getElementById("shopSp");
    const ppEl = document.getElementById("shopPp");
    const syEl = document.getElementById("shopSy");
    const statusEl = document.querySelector("#shop .shop-sub-status");
    if (this.matchMode === "sandbox") {
      if (lead) lead.textContent = "";
      if (roundEl) roundEl.textContent = "";
      if (tail) tail.textContent = "";
      if (statusEl) statusEl.hidden = true;
    } else {
      if (statusEl) statusEl.hidden = false;
    }
    if (this.matchMode === "pve" && data.round === 0) {
      if (lead) lead.textContent = "Prepare for ";
      if (roundEl) roundEl.textContent = "Boss 1";
      if (tail) tail.textContent = " — ";
    } else if (this.matchMode === "pve") {
      if (lead) lead.textContent = "Encounter ";
      if (roundEl) roundEl.textContent = String(data.round);
      if (tail) tail.textContent = " complete — ";
    } else {
      if (lead) lead.textContent = "Round ";
      if (roundEl) roundEl.textContent = data.round;
      if (tail) tail.textContent = " complete — ";
    }
    if (goldEl) goldEl.textContent = view.gold;
    if (spEl) spEl.textContent = view.sp ?? 0;
    if (ppEl) ppEl.textContent = view.pp ?? 0;
    if (syEl) syEl.textContent = view.sy ?? 0;
    if (tail && data.planning) {
      tail.textContent = data.shopLocked
        ? " choices locked — "
        : " · click a pick again to undo — Ready locks in — ";
    }
    // current passive items the warlock owns (capped at UPGRADE.maxItems total)
    const itemsHeld = ITEM_ORDER.reduce((n, id) => n + ((view.items && view.items[id]) || 0), 0);
    const itemCap = UPGRADE.maxItems || 6;
    const itemsFull = itemsHeld >= itemCap;
    const ownedEl = document.getElementById("shopOwned");
    if (ownedEl) {
      const itemsKey = ITEM_ORDER.map(id => (view.items && view.items[id]) || 0).join(",");
      if (this._shopItemsKey !== itemsKey) {
        this._shopItemsKey = itemsKey;
        const owned = ITEM_ORDER.filter(id => (view.items && view.items[id]) > 0);
        const label = `<span class="owned-label">Your items (${itemsHeld}/${itemCap})</span>`;
        if (!owned.length) {
          ownedEl.innerHTML = `<span class="owned-none">No items yet — buy in this tab (max ${itemCap})</span>`;
        } else {
          ownedEl.innerHTML = label + owned.map(id => {
            const it = ITEMS[id], n = view.items[id];
            return `<span class="owned-chip" ${tipAttr("item", id)} data-tip-count="${n}">${it.icon}<span class="owned-name">${escapeHtml(it.name)}</span>${n > 1 ? `<b>×${n}</b>` : ""}</span>`;
          }).join("");
        }
      }
    }

    const grid = document.getElementById("shopGrid");
    grid.className = "shop-categories";
    const committed = view.committed || {};
    const passives = view.passives || {};
    const loadout = view.loadout || {};
    const barFull = isBarFull(loadout);
    // Planning toggles preview passives — skip unlock anims until Ready commits buys.
    const newPassivesBySpell = (data.planning && !data.shopLocked)
      ? {}
      : detectNewPassives(this._shopPrevPassives, passives);
    this._shopPrevPassives = clonePassives(passives);

    if (!grid.querySelector(".category-block")) {
      grid.innerHTML = "";
      buildShopSpellsGrid(this, grid, view, buy, {
        committed, passives, loadout, barFull, newPassivesBySpell,
      });
      this._shopLoadoutKey = shopLoadoutKey(loadout);
      this._shopBarFull = barFull;
    } else {
      patchShopSpellsGrid(this, grid, view, buy, {
        committed, passives, loadout, barFull, newPassivesBySpell,
      });
    }
    grid._synergyHoverCtx = {
      loadout,
      committed,
      passives,
    };
    wireSynergyPartnerHoverGrid(grid);

    patchShopItemsPanel(document.getElementById("shopItems"), view, onBuy, itemsFull);

    this.wireShopTabs();
    this.renderCombatReport();
    refreshSpellCatalogSearch();
  }

function synergyLinkIcon(className = "synergy-partner-link") {
    return `<span class="${className}" aria-hidden="true"><svg viewBox="0 0 16 16" width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 9.5a3 3 0 0 0 4.24 0l2-2a3 3 0 0 0-4.24-4.24L7.5 4.3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M9.5 6.5a3 3 0 0 0-4.24 0l-2 2a3 3 0 0 0 4.24 4.24l1-1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></span>`;
  }

function synergyPartnerCardHTML(partnerId, loadout, committed, requiresLocked, opts) {
    const ps = SPELLS[partnerId];
    if (!ps) return "";
    const ownedRow = !!opts?.ownedRow;
    const unlockHint = opts?.unlockHint || "";
    const unlocked = requiresLocked
      ? synergySpellLockedIn(loadout, committed, partnerId)
      : synergySpellUnlocked(loadout, partnerId);
    const unlockEl = !ownedRow && unlockHint
      ? `<span class="synergy-partner-unlock">${escapeHtml(unlockHint)}</span>`
      : "";
    const tagEl = ownedRow ? `<div class="passive-node-tag">Synergy</div>` : "";
    return `<div class="synergy-partner-card${unlocked ? " unlocked" : " locked-partner"}">
      ${unlockEl}
      ${synergyLinkIcon()}
      <span class="synergy-partner-icon" style="background:${ps.color}33;border:1px solid ${ps.color}">${spellIconInner(partnerId)}</span>
      <span class="synergy-partner-name">${escapeHtml(ps.name)}</span>
      <span class="synergy-partner-slot">${escapeHtml(shopCategoryLabel(ps.shopCategory) || ps.name)}</span>
      ${tagEl}
    </div>`;
  }

function passiveSynergyPairHTML(n, loadout, committed, synergyBlocked, ownedRow) {
    if (!n.synergy || !n.requiresSpell) return "";
    const unlockHint = synergyBlocked ? synergyUnlockLabel(n) : "";
    const card = synergyPartnerCardHTML(
      n.requiresSpell, loadout, committed, n.requiresSpellLocked,
      { unlockHint: ownedRow ? "" : unlockHint, ownedRow },
    );
    const unlockLeft = ownedRow && unlockHint
      ? `<div class="passive-node-unlock-hint">${escapeHtml(unlockHint)}</div>`
      : "";
    return `<div class="passive-synergy-pair">${unlockLeft}${card}</div>`;
  }

function passiveOwnedDetailHTML(n) {
    const parts = passiveBonusLines(n);
    if (parts.length) {
      return `<div class="passive-node-bonus">${parts.map(p =>
        `<span class="passive-node-bonus-chip">${escapeHtml(p)}</span>`).join("")}</div>`;
    }
    if (n.desc) return `<div class="passive-node-desc">${escapeHtml(n.desc)}</div>`;
    return "";
  }

function shopOwnedSpellStatsHTML(spellId, data) {
    const stats = ownedSpellStats(spellId, data.passives);
    if (!stats.length) return "";
    return `<div class="shop-owned-spell-stats">${stats.map(([k, v]) =>
      `<span class="shop-owned-stat"><b>${escapeHtml(k)}</b> ${escapeHtml(String(v))}</span>`).join("")}</div>`;
  }

function passiveNodeTextHTML(n, loadout, committed, synergyBlocked, ownedRow) {
    const name = passiveShopName(n);
    if (!n.synergy) {
      if (ownedRow) {
        return `
            <div class="passive-node-name">${escapeHtml(name)}</div>
            ${passiveOwnedDetailHTML(n)}`;
      }
      return `
            <div class="passive-node-name">${escapeHtml(name)}</div>
            <div class="passive-node-desc">${escapeHtml(n.desc)}</div>`;
    }
    if (ownedRow) {
      const desc = n.desc ? `<div class="passive-node-desc">${escapeHtml(n.desc)}</div>` : "";
      return `
            <div class="passive-node-heading">
              <div class="passive-node-name">${escapeHtml(name)}</div>
            </div>
            ${desc}
            ${passiveSynergyPairHTML(n, loadout, committed, synergyBlocked, true)}`;
    }
    return `
            <div class="passive-node-heading">
              <div class="passive-node-name">${escapeHtml(name)}</div>
              <div class="passive-node-tag">Synergy</div>
            </div>
            ${passiveSynergyPairHTML(n, loadout, committed, synergyBlocked, false)}
            <div class="passive-node-desc">${escapeHtml(n.desc)}</div>`;
  }

function syncSynergyPartnerCard(node, n, owned, synergyBlocked, loadout, committed) {
    if (!n.synergy || !n.requiresSpell) return;
    const card = node.querySelector(".synergy-partner-card");
    if (!card) return;
    const ownedRow = !!node.closest(".skill-tree-owned-row");
    const unlockHint = synergyBlocked && !owned ? synergyUnlockLabel(n) : "";
    card.querySelector(".synergy-partner-unlock")?.remove();
    if (ownedRow) {
      const pair = node.querySelector(".passive-synergy-pair");
      let hintEl = pair?.querySelector(".passive-node-unlock-hint");
      if (unlockHint) {
        if (!hintEl && pair) {
          hintEl = document.createElement("div");
          hintEl.className = "passive-node-unlock-hint";
          pair.insertBefore(hintEl, card);
        }
        if (hintEl) {
          hintEl.textContent = unlockHint;
          hintEl.hidden = false;
        }
      } else {
        hintEl?.remove();
      }
    } else if (unlockHint) {
      let unlockEl = document.createElement("span");
      unlockEl.className = "synergy-partner-unlock";
      unlockEl.textContent = unlockHint;
      card.insertBefore(unlockEl, card.firstChild);
    }
    const partnerUnlocked = n.requiresSpellLocked
      ? synergySpellLockedIn(loadout, committed, n.requiresSpell)
      : synergySpellUnlocked(loadout, n.requiresSpell);
    card.classList.toggle("unlocked", partnerUnlocked);
    card.classList.toggle("locked-partner", !partnerUnlocked);
  }

function shopSynergiesHTML(spellId, loadout) {
    const synergies = synergiesHostedBy(spellId);
    const content = synergies.length
      ? synergies.map(n => {
          const preview = SpellPreview?.has?.(spellId)
            ? ` data-synergy-preview="${escapeHtml(n.id)}"`
            : "";
          const partner = n.requiresSpell ? ` data-synergy-partner="${escapeHtml(n.requiresSpell)}"` : "";
          const partnerLocked = n.requiresSpellLocked ? ` data-synergy-partner-locked="1"` : "";
          return `<span class="shop-synergy-orb" ${tipAttr("passive", n.id)} data-tip-spell="${escapeHtml(spellId)}"${partner}${partnerLocked}${preview}>${synergyOrbInner(n.id, n.name)}</span>`;
        }).join("")
      : `<span class="shop-synergy-spacer" aria-hidden="true"></span>`;
    return `<div class="shop-synergy-row">${content}</div>`;
  }

Game.prototype.buildShopSpellCard = function (id, data, onBuy, opts) {
    const card = document.createElement("div");
    if (!SPELLS[id]) return card;
    populateShopSpellCard(card, this, id, data, onBuy, opts);
    return card;
  }

function clonePassives(passives) {
    const out = {};
    if (!passives) return out;
    for (const spellId in passives) out[spellId] = [...(passives[spellId] || [])];
    return out;
  }

function detectNewPassives(prev, curr) {
    const out = {};
    if (!prev) return out;
    const spells = new Set([...Object.keys(prev), ...Object.keys(curr || {})]);
    for (const spellId of spells) {
      const was = new Set(prev[spellId] || []);
      const added = (curr?.[spellId] || []).filter(id => !was.has(id));
      if (added.length === 1) out[spellId] = added[0];
      else if (added.length > 1) out[spellId] = added;
    }
    return out;
  }

function ensureSkillTreeRevealed(tree) {
    if (!tree._skillTreeRevealedPassives) tree._skillTreeRevealedPassives = new Set();
    return tree._skillTreeRevealedPassives;
  }

function enqueuePassiveUnlockAnim(tree, passiveId) {
    if (!passiveId) return;
    if (!tree._skillTreeUnlockQueue) tree._skillTreeUnlockQueue = [];
    const q = tree._skillTreeUnlockQueue;
    if (tree._skillTreeAnimatingPassive === passiveId) return;
    if (q.includes(passiveId)) return;
    q.push(passiveId);
    drainPassiveUnlockQueue(tree);
  }

function enqueuePassiveUnlocks(tree, entry) {
    if (!entry) return;
    const ids = Array.isArray(entry) ? entry : [entry];
    for (const id of ids) enqueuePassiveUnlockAnim(tree, id);
  }

function drainPassiveUnlockQueue(tree) {
    if (tree._skillTreeAnimating) return;
    const passiveId = tree._skillTreeUnlockQueue?.shift();
    if (!passiveId) return;
    const node = tree.querySelector(`[data-passive-id="${passiveId}"]`);
    if (!node) {
      drainPassiveUnlockQueue(tree);
      return;
    }
    tree._skillTreeAnimating = true;
    tree._skillTreeAnimatingPassive = passiveId;
    node.classList.remove("owned-reveal");
    node.classList.add("owned", "just-unlocked");
    tree._skillTreeRedraw?.();
    requestAnimationFrame(() => requestAnimationFrame(() => runPassiveUnlockAnim(tree, passiveId)));
  }

function shopSpellBuyBtn(game, card, id, s, data, onBuy, opts) {
    const { owned, barFull } = opts;
    const pending = planSpellPending(data, id);
    const locked = !!data.shopLocked;
    const st = spellAvail(id);
    const btn = document.createElement("button");
    btn.className = "buy-btn" + (owned ? " maxed" : pending ? " shop-pending" : " unlock");
    const canBuy = spellShopPurchasable(id, game.matchMode);
    card.classList.remove("unaffordable", "shop-pending-card");
    if (pending) card.classList.add("shop-pending-card");
    if (owned) {
      btn.textContent = "OWNED";
      btn.disabled = true;
    } else if (pending) {
      btn.textContent = "Undo";
      btn.title = "Selected for this round — click to unassign";
      btn.disabled = locked;
      if (!locked) btn.onclick = () => onBuy("spell", id);
    } else if (st === "coming_soon") {
      btn.textContent = "Coming soon";
      btn.disabled = true;
      card.classList.add("unaffordable");
    } else if (st === "disabled" && !canBuy) {
      btn.textContent = "Disabled";
      btn.disabled = true;
      card.classList.add("unaffordable");
    } else if (barFull) {
      btn.textContent = "Bar full";
      btn.disabled = true;
      card.classList.add("unaffordable");
    } else {
      const spCost = spellCommitSp(s, owned);
      btn.textContent = `${spCost} SP`;
      btn.disabled = locked || (data.sp ?? 0) < spCost;
      if (btn.disabled) card.classList.add("unaffordable");
      if (!locked) btn.onclick = () => { if (canBuy && !barFull) onBuy("spell", id); };
    }
    return btn;
  }

function populateShopSpellCard(card, game, id, data, onBuy, opts) {
    const s = SPELLS[id];
    if (!s || !card) return;
    const { owned, showBuy, barFull } = opts;
    const st = spellAvail(id);
    const partnerLit = synergyPartnerLitSpellIds(
      data.loadout || {}, data.committed || {},
    ).has(id);
    card.className = "spell-card shop-spell-card" + (owned ? " owned" : "") +
      (partnerLit ? " synergy-partner-lit" : "") +
      (st === "coming_soon" ? " spell-coming-soon" : st === "disabled" ? " spell-disabled" : "");
    card.setAttribute("data-tip-kind", "spell");
    card.setAttribute("data-tip-id", id);
    card.setAttribute("data-spell-id", id);
    if (SpellPreview.has(id)) {
      card.classList.add("spell-card-previewable");
      card.setAttribute("data-spell-preview", id);
    } else {
      card.classList.remove("spell-card-previewable");
      card.removeAttribute("data-spell-preview");
    }
    const ownedStats = opts.detailRow ? shopOwnedSpellStatsHTML(id, data) : "";
    card.innerHTML = `
      <div class="spell-icon shop-spell-icon" style="background:${s.color}33;border:1px solid ${s.color}">${spellIconInner(id)}</div>
      <div class="shop-spell-meta">
        <div class="spell-name">${escapeHtml(s.name)}</div>
        ${ownedStats}
        ${opts.detailRow ? "" : shopSynergiesHTML(id, data.loadout)}
      </div>`;
    card.classList.remove("shop-pending-card");
    if (planSpellPending(data, id) && !owned) card.classList.add("shop-pending-card");
    if (showBuy) card.appendChild(shopSpellBuyBtn(game, card, id, s, data, onBuy, opts));
  }

function syncShopSpellCard(game, card, id, data, onBuy, opts) {
    populateShopSpellCard(card, game, id, data, onBuy, opts);
  }

function buildOwnedSkillUnit(game, spellId, data, onBuy, ctx) {
    const { passives, loadout, committed, newPassivesBySpell } = ctx;
    const plannedOnly = spellPlannedOnly(data, spellId);
    const spellCard = game.buildShopSpellCard(spellId, data, onBuy, {
      owned: spellOwnedCommitted(data, spellId),
      showBuy: plannedOnly && !data.shopLocked,
      detailRow: true,
      slot: slotOfSpell(loadout, spellId),
    });
    const tree = game.buildSkillTree(spellId, passives, {
      sp: data.sp ?? 0, pp: data.pp ?? 0, sy: data.sy ?? 0,
    }, onBuy, {
      justUnlockedId: newPassivesBySpell[spellId] || null,
      loadout, committed,
      layout: "owned-row",
    });
    if (tree) syncSkillTreeState(game, tree, spellId, data, passives, onBuy, loadout, committed);
    return wrapSpellSkillUnit(spellCard, tree, { ownedRow: true }, data, spellId);
  }

function refreshOwnedSkillUnit(game, unit, spellId, data, onBuy, ctx) {
    const { passives, loadout, committed, newPassivesBySpell } = ctx;
    const header = unit.querySelector(":scope > .shop-spell-card");
    if (header) {
      syncShopSpellCard(game, header, spellId, data, onBuy, {
        owned: spellOwnedCommitted(data, spellId),
        showBuy: spellPlannedOnly(data, spellId) && !data.shopLocked,
        barFull: false, detailRow: true,
        slot: slotOfSpell(loadout, spellId),
      });
    }
    const justUnlocked = newPassivesBySpell[spellId] || null;
    let tree = unit.querySelector(":scope > .skill-tree");
    if (!tree || !tree.classList.contains("skill-tree-owned-row")) {
      if (tree?._skillTreeRO) tree._skillTreeRO.disconnect();
      tree?.remove();
      tree = game.buildSkillTree(spellId, passives, {
        sp: data.sp ?? 0, pp: data.pp ?? 0, sy: data.sy ?? 0,
      }, onBuy, {
        justUnlockedId: justUnlocked,
        loadout, committed,
        layout: "owned-row",
      });
      if (tree) {
        unit.appendChild(tree);
        syncSkillTreeState(game, tree, spellId, data, passives, onBuy, loadout, committed);
      }
      syncOwnedSkillUnitClasses(unit, data, spellId);
      return;
    }
    syncSkillTreeState(game, tree, spellId, data, passives, onBuy, loadout, committed);
    syncOwnedSkillUnitClasses(unit, data, spellId);
    enqueuePassiveUnlocks(tree, justUnlocked);
  }

function syncSkillTreeState(game, treeEl, spellId, data, passives, onBuy, loadout, committed) {
    const fullTree = PASSIVE_TREES[spellId];
    if (!fullTree?.length || !treeEl) return;
    const pp = data.pp ?? 0;
    const sy = data.sy ?? 0;
    const shopLocked = !!data.shopLocked;
    const animPassive = treeEl._skillTreeAnimatingPassive;
    const revealed = treeEl._skillTreeRevealedPassives;
    const previewPassives = data.passives || passives;
    for (const n of fullTree) {
      const node = treeEl.querySelector(`[data-passive-id="${n.id}"]`);
      if (!node) continue;
      const ownedReal = passiveOwned(data.basePassives || passives, spellId, n.id);
      const pending = planPassivePending(data, spellId, n.id);
      const owned = ownedReal || pending;
      const animating = animPassive === n.id;
      const showReveal = owned && !animating && (ownedReal || revealed?.has(n.id));
      const prereqOk = passivePrereqsMet(previewPassives, spellId, n);
      const synergyBlocked = n.synergy && n.requiresSpell &&
        !synergyPartnerMet(loadout, committed, n);
      const synergyExclusive = synergyExclusiveBlocked(previewPassives, spellId, n);
      const nodeLocked = !owned && (!prereqOk || synergyBlocked || synergyExclusive);
      node.className = "passive-node" + (n.synergy ? " synergy" : "") +
        (owned ? " owned" : "") +
        (pending ? " shop-pending" : "") +
        (animating ? " just-unlocked" : "") +
        (showReveal ? " owned-reveal" : "") +
        (nodeLocked ? " locked" : "");
      if (!animating) {
        node.classList.remove("unaffordable", "just-unlocked", "border-revealing");
      } else {
        node.classList.remove("unaffordable");
        if (node.querySelector(".passive-border-trace")) node.classList.add("border-revealing");
      }
      syncSynergyPartnerCard(node, n, owned, synergyBlocked, loadout, committed);
      syncSynergyPreviewAttrs(node, n, owned, synergyBlocked);
      if (synergyBlocked && !owned && !synergyExclusive) node.dataset.synergyPartnerBlocked = "1";
      else delete node.dataset.synergyPartnerBlocked;
      const ownedRow = treeEl.classList.contains("skill-tree-owned-row");
      if (ownedReal && ownedRow) {
        node.querySelector(".buy-btn")?.remove();
        continue;
      }
      let btn = node.querySelector(".buy-btn");
      if (!btn) {
        btn = document.createElement("button");
        btn.className = "buy-btn";
        node.appendChild(btn);
      }
      const buyCost = passiveBuyCost(n);
      const canAfford = n.synergy ? sy >= buyCost : pp >= buyCost;
      btn.className = "buy-btn";
      btn.onclick = null;
      if (ownedReal) {
        btn.textContent = "OWNED";
        btn.classList.add("maxed");
        btn.disabled = true;
      } else if (pending) {
        btn.textContent = "Undo";
        btn.title = "Selected for this round — click to unassign";
        btn.classList.add("shop-pending");
        btn.disabled = shopLocked;
        if (!shopLocked) btn.onclick = () => onBuy("passive", n.id);
      } else if (synergyBlocked || synergyExclusive || nodeLocked) {
        btn.textContent = synergyExclusive ? synergyExclusiveLabel(previewPassives, spellId, n) : "LOCKED";
        btn.disabled = true;
      } else {
        btn.textContent = passiveBuyLabel(n);
        btn.disabled = shopLocked || !canAfford;
        if (btn.disabled) node.classList.add("unaffordable");
        if (!shopLocked) btn.onclick = () => onBuy("passive", n.id);
      }
    }
    if (treeEl._skillTreeRedraw && !treeEl._skillTreeAnimating) treeEl._skillTreeRedraw();
  }

function ownedSkillsHeadText(count) {
    return `YOUR SKILLS — ${count}/${LOADOUT.maxEquipped} Equipped`;
  }

function buildShopOwnedSection(game, data, onBuy, ctx) {
    const ownedSpells = SLOT_ORDER.map(s => ctx.loadout[s]).filter(Boolean);
    if (!ownedSpells.length) return null;
    const ownedSec = document.createElement("div");
    ownedSec.className = "shop-owned-spells";
    const ownedHead = document.createElement("div");
    ownedHead.className = "shop-section-title shop-owned-head";
    ownedHead.textContent = ownedSkillsHeadText(ownedSpells.length);
    ownedSec.appendChild(ownedHead);
    const ownedList = document.createElement("div");
    ownedList.className = "shop-owned-list";
    for (const id of ownedSpells) {
      ownedList.appendChild(buildOwnedSkillUnit(game, id, data, onBuy, ctx));
    }
    ownedSec.appendChild(ownedList);
    return ownedSec;
  }

function patchShopOwnedSection(game, grid, data, onBuy, ctx) {
    const ownedSpells = SLOT_ORDER.map(s => ctx.loadout[s]).filter(Boolean);
    let ownedSec = grid.querySelector(".shop-owned-spells");
    if (!ownedSpells.length) {
      ownedSec?.remove();
      return;
    }
    if (!ownedSec) {
      ownedSec = buildShopOwnedSection(game, data, onBuy, ctx);
      if (ownedSec) grid.insertBefore(ownedSec, grid.firstChild);
      return;
    }
    const head = ownedSec.querySelector(".shop-owned-head");
    if (head) head.textContent = ownedSkillsHeadText(ownedSpells.length);
    let row = ownedSec.querySelector(".shop-owned-list");
    if (!row) {
      ownedSec.querySelector(".shop-owned-scroller")?.remove();
      row = document.createElement("div");
      row.className = "shop-owned-list";
      ownedSec.appendChild(row);
    }
    const existing = {};
    row.querySelectorAll(".spell-skill-unit").forEach(unit => {
      const id = unit.querySelector("[data-spell-id]")?.getAttribute("data-spell-id");
      if (id) existing[id] = unit;
    });
    for (const id of Object.keys(existing)) {
      if (!ownedSpells.includes(id)) existing[id].remove();
    }
    for (let i = 0; i < ownedSpells.length; i++) {
      const id = ownedSpells[i];
      let unit = existing[id];
      if (!unit) {
        unit = buildOwnedSkillUnit(game, id, data, onBuy, ctx);
        const before = row.children[i] || null;
        row.insertBefore(unit, before);
        continue;
      }
      unit.classList.add("spell-skill-unit-owned-row");
      refreshOwnedSkillUnit(game, unit, id, data, onBuy, ctx);
      syncOwnedSkillUnitClasses(unit, data, id);
      if (row.children[i] !== unit) row.insertBefore(unit, row.children[i] || null);
    }
  }

function buildShopSpellsGrid(game, grid, data, onBuy, ctx) {
    const ownedSec = buildShopOwnedSection(game, data, onBuy, ctx);
    if (ownedSec) grid.appendChild(ownedSec);
    for (const cat of SHOP_CATEGORY_ORDER) {
      const ids = SPELLS_IN_CATEGORY(cat);
      if (!ids.length) continue;
      const block = document.createElement("div");
      block.className = "category-block";
      block.dataset.shopCat = cat;
      const head = document.createElement("div");
      head.className = "category-head";
      head.textContent = shopCategoryLabel(cat);
      block.appendChild(head);
      const opts = document.createElement("div");
      opts.className = "category-options";
      ids.forEach(id => {
        const owned = spellOwnedCommitted(data, id);
        opts.appendChild(game.buildShopSpellCard(id, data, onBuy, {
          owned, showBuy: true, barFull: ctx.barFull, slot: slotOfSpell(ctx.loadout, id),
        }));
      });
      block.appendChild(opts);
      grid.appendChild(block);
    }
  }

function shopLoadoutKey(loadout) {
    return SLOT_ORDER.map(s => loadout[s] || "").join("|");
  }

function shopWalletKey(data) {
    const plan = data.planning
      ? `${JSON.stringify(data.planSpells || [])}|${JSON.stringify(data.planPassives || {})}|${data.shopLocked ? 1 : 0}`
      : "";
    return `${data.sp ?? 0}|${data.pp ?? 0}|${data.sy ?? 0}|${plan}`;
  }

function patchShopSpellsGrid(game, grid, data, onBuy, ctx) {
    patchShopOwnedSection(game, grid, data, onBuy, ctx);
    const loadoutKey = shopLoadoutKey(ctx.loadout);
    const walletKey = shopWalletKey(data);
    const loadoutChanged = game._shopLoadoutKey !== loadoutKey;
    const barFullChanged = game._shopBarFull !== ctx.barFull;
    const walletChanged = game._shopWalletKey !== walletKey;
    game._shopLoadoutKey = loadoutKey;
    game._shopBarFull = ctx.barFull;
    game._shopWalletKey = walletKey;
    if (!loadoutChanged && !barFullChanged && !walletChanged) return;
    for (const cat of SHOP_CATEGORY_ORDER) {
      const ids = SPELLS_IN_CATEGORY(cat);
      if (!ids.length) continue;
      let block = grid.querySelector(`.category-block[data-shop-cat="${cat}"]`);
      if (!block) {
        block = document.createElement("div");
        block.className = "category-block";
        block.dataset.shopCat = cat;
        const head = document.createElement("div");
        head.className = "category-head";
        head.textContent = shopCategoryLabel(cat);
        block.appendChild(head);
        const opts = document.createElement("div");
        opts.className = "category-options";
        block.appendChild(opts);
        grid.appendChild(block);
      }
      const opts = block.querySelector(".category-options");
      const byId = {};
      opts.querySelectorAll(".shop-spell-card[data-spell-id]").forEach(card => {
        byId[card.getAttribute("data-spell-id")] = card;
      });
      for (const id of ids) {
        const owned = spellOwnedCommitted(data, id);
        let card = byId[id];
        if (card) {
          syncShopSpellCard(game, card, id, data, onBuy, {
            owned, showBuy: true, barFull: ctx.barFull, slot: slotOfSpell(ctx.loadout, id),
          });
        } else {
          card = game.buildShopSpellCard(id, data, onBuy, {
            owned, showBuy: true, barFull: ctx.barFull, slot: slotOfSpell(ctx.loadout, id),
          });
          opts.appendChild(card);
        }
      }
    }
  }

function populateShopItemCard(card, id, data, onBuy, itemsFull) {
    const it = ITEMS[id];
    if (!it || !card) return;
    const owned = (data.items && data.items[id]) || 0;
    const cost = itemCost(it, owned);
    card.className = "spell-card" + (owned ? " owned" : "");
    card.classList.remove("unaffordable");
    card.setAttribute("data-tip-kind", "item");
    card.setAttribute("data-tip-id", id);
    if (owned) card.setAttribute("data-tip-count", String(owned));
    else card.removeAttribute("data-tip-count");
    card.innerHTML = `
      <div class="spell-icon" style="background:rgba(138,134,166,0.2);border:1px solid #8a86a6">${it.icon}</div>
      <div class="spell-info">
        <div class="spell-name">${it.name}${owned ? ` ×${owned}` : ""}</div>
        <div class="spell-key">${it.desc}</div>
      </div>`;
    const btn = document.createElement("button");
    btn.className = "buy-btn";
    if (!it.stackable && owned > 0) {
      btn.textContent = "OWNED"; btn.classList.add("maxed"); btn.disabled = true;
    } else if (itemsFull) {
      btn.textContent = "FULL"; btn.classList.add("maxed"); btn.disabled = true;
    } else {
      btn.textContent = `${cost}g`;
      btn.disabled = data.gold < cost;
      if (btn.disabled) card.classList.add("unaffordable");
      btn.onclick = () => onBuy("item", id);
    }
    card.appendChild(btn);
  }

function patchShopItemsPanel(ig, data, onBuy, itemsFull) {
    if (!ig) return;
    const byId = {};
    ig.querySelectorAll(".spell-card[data-tip-id]").forEach(card => {
      byId[card.getAttribute("data-tip-id")] = card;
    });
    const frag = document.createDocumentFragment();
    for (const id of ITEM_ORDER) {
      let card = byId[id];
      if (!card) {
        card = document.createElement("div");
      }
      populateShopItemCard(card, id, data, onBuy, itemsFull);
      frag.appendChild(card);
    }
    ig.replaceChildren(frag);
  }

function startPassiveBorderReveal(node, wrap, dotEl) {
    const w = node.offsetWidth;
    const h = node.offsetHeight;
    if (w < 4 || h < 4) return;

    const unit = wrap.closest(".spell-skill-unit") || wrap;
    const originRect = unit.getBoundingClientRect();
    const nodeRect = node.getBoundingClientRect();
    let ax = w * 0.5;
    let ay = 0;
    if (dotEl) {
      ax = originRect.left + parseFloat(dotEl.getAttribute("cx") || "0") - nodeRect.left;
      ay = originRect.top + parseFloat(dotEl.getAttribute("cy") || "0") - nodeRect.top;
    }

    const borderR = passiveNodeBorderRadius(node);
    startBorderReveal(node, ax, ay, { borderR, borderMs: PICK_UNLOCK_BORDER_MS });
  }

function runPassiveUnlockAnim(wrap, passiveId) {
    const node = wrap.querySelector(`[data-passive-id="${passiveId}"]`);
    const edges = wrap._skillTreeEdges || [];
    const edge = edges.find(e => e.toKey === passiveId);
    const finish = () => {
      wrap._skillTreeAnimating = false;
      wrap._skillTreeAnimatingPassive = null;
      if (node) {
        node.classList.remove("just-unlocked", "border-revealing");
        node.classList.add("owned-reveal");
        ensureSkillTreeRevealed(wrap).add(passiveId);
        node.querySelector(".passive-border-trace")?.remove();
      }
      wrap._skillTreeRedraw?.();
      drainPassiveUnlockQueue(wrap);
    };
    if (!node) {
      wrap._skillTreeAnimating = false;
      wrap._skillTreeAnimatingPassive = null;
      drainPassiveUnlockQueue(wrap);
      return;
    }
    wrap._skillTreeAnimating = true;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      finish();
      return;
    }
    const startBorder = (dot) => {
      startPassiveBorderReveal(node, wrap, dot || null);
      setTimeout(finish, PICK_UNLOCK_BORDER_MS);
    };
    if (!edge) {
      startBorder(null);
      return;
    }
    const { path, fromDot, toDot } = edge;
    const len = path.getTotalLength();
    path.style.strokeDasharray = `${len}`;
    path.style.strokeDashoffset = `${len}`;
    path.classList.remove("edge-lit", "edge-complete");
    path.classList.add("edge-anim-draw");
    fromDot.classList.remove("joint-lit");
    toDot.classList.remove("joint-lit");
    fromDot.classList.add("joint-anim-start");
    setTimeout(() => {
      fromDot.classList.remove("joint-anim-start");
      fromDot.classList.add("joint-lit");
      requestAnimationFrame(() => {
        path.style.transition = `stroke-dashoffset ${PICK_UNLOCK_EDGE_MS}ms ease-out`;
        path.style.strokeDashoffset = "0";
      });
    }, PICK_UNLOCK_START_MS);
    setTimeout(() => {
      toDot.classList.add("joint-lit", "joint-anim-pop");
      path.style.transition = "";
      startBorder(toDot);
    }, PICK_UNLOCK_START_MS + PICK_UNLOCK_EDGE_MS + PICK_UNLOCK_DOT_MS);
  }

function syncOwnedSkillUnitClasses(unit, data, spellId) {
    if (!unit) return;
    unit.classList.toggle("owned", spellOwnedCommitted(data, spellId));
    unit.classList.toggle("shop-planned", spellPlannedOnly(data, spellId));
    unit.classList.toggle("synergy-partner-lit", synergyPartnerLitSpellIds(
      data.loadout || {}, data.committed || {},
    ).has(spellId));
  }

function wrapSpellSkillUnit(spellCard, tree, opts, data, spellId) {
    const unit = document.createElement("div");
    unit.className = "spell-skill-unit" + (opts?.ownedRow ? " spell-skill-unit-owned-row" : "");
    unit.appendChild(spellCard);
    if (tree) unit.appendChild(tree);
    if (opts?.ownedRow && data && spellId) syncOwnedSkillUnitClasses(unit, data, spellId);
    else {
      if (spellCard.classList.contains("owned")) unit.classList.add("owned");
      if (spellCard.classList.contains("shop-pending-card")) unit.classList.add("shop-planned");
      if (spellCard.classList.contains("synergy-partner-lit")) unit.classList.add("synergy-partner-lit");
    }
    return unit;
  }

const SYNERGY_HOVER_EDGE_MS = 450;
const SYNERGY_HOVER_PARTNER_GAP = 52;
const SYNERGY_HOVER_TIP_PAD = 14;
const SYNERGY_HOVER_VIEW_PAD = 8;
const SYNERGY_HOVER_SHOP_PAD = 8;

function synergyHoverRectFromEl(el) {
    if (!el || el.classList.contains("hidden")) return null;
    const r = el.getBoundingClientRect();
    if (r.width < 2 || r.height < 2) return null;
    return r;
  }

/** Skill detail / spell-preview popovers to avoid overlapping. */
function synergyHoverDetailPopoverRects() {
    const out = [];
    const push = (el) => {
      const r = synergyHoverRectFromEl(el);
      if (r) out.push(r);
    };
    push(Tip.el);
    const sp = window.SpellPreview;
    if (sp) {
      push(sp.Tip?.el);
      push(sp.SimTip?.el);
    }
    return out;
  }

function synergyHoverBoundRects() {
    const bounds = [{
      left: SYNERGY_HOVER_VIEW_PAD,
      top: SYNERGY_HOVER_VIEW_PAD,
      right: window.innerWidth - SYNERGY_HOVER_VIEW_PAD,
      bottom: window.innerHeight - SYNERGY_HOVER_VIEW_PAD,
    }];
    const shop = document.getElementById("shop");
    const r = synergyHoverRectFromEl(shop);
    if (r) {
      bounds.push({
        left: r.left + SYNERGY_HOVER_SHOP_PAD,
        top: r.top + SYNERGY_HOVER_SHOP_PAD,
        right: r.right - SYNERGY_HOVER_SHOP_PAD,
        bottom: r.bottom - SYNERGY_HOVER_SHOP_PAD,
      });
    }
    return bounds;
  }

function synergyHoverRectsOverlap(a, b, pad = 0) {
    return !(a.right + pad < b.left || a.left - pad > b.right ||
      a.bottom + pad < b.top || a.top - pad > b.bottom);
  }

function synergyHoverPartnerGlobal(left, top, pW, pH, originRect) {
    const leftG = originRect.left + left;
    const topG = originRect.top + top;
    return {
      left: leftG, top: topG, right: leftG + pW, bottom: topG + pH,
      width: pW, height: pH,
    };
  }

function synergyHoverCollides(rect, obstacles, pad) {
    for (const ob of obstacles) {
      if (synergyHoverRectsOverlap(rect, ob, pad)) return true;
    }
    return false;
  }

function synergyHoverWithinBounds(rect, bounds, pad) {
    for (const b of bounds) {
      if (rect.left < b.left + pad || rect.top < b.top + pad ||
          rect.right > b.right - pad || rect.bottom > b.bottom - pad) return false;
    }
    return true;
  }

function synergyHoverPartnerSlots(sRect, cRect, pW, pH) {
    const sl = sRect.left - cRect.left;
    const st = sRect.top - cRect.top;
    const sr = sl + sRect.width;
    const sb = st + sRect.height;
    const scx = sl + sRect.width * 0.5;
    const scy = st + sRect.height * 0.5;
    const g = SYNERGY_HOVER_PARTNER_GAP;
    return {
      above: { left: scx - pW * 0.5, top: st - pH - g, rank: 0 },
      below: { left: scx - pW * 0.5, top: sb + g, rank: 1 },
      left: { left: sl - pW - g, top: scy - pH * 0.5, rank: 2 },
      right: { left: sr + g, top: scy - pH * 0.5, rank: 3 },
    };
  }

function synergyHoverClampLeft(left, containerW, pW) {
    return Math.max(-12, Math.min(left, containerW - pW + 12));
  }

function synergyHoverEvaluateSlot(slot, cRect, pW, pH, bounds, popovers, containerW) {
    const left = synergyHoverClampLeft(slot.left, containerW, pW);
    const top = slot.top;
    const global = synergyHoverPartnerGlobal(left, top, pW, pH, cRect);
    return {
      left, top, rank: slot.rank,
      inBounds: synergyHoverWithinBounds(global, bounds, SYNERGY_HOVER_TIP_PAD),
      hitsPopover: synergyHoverCollides(global, popovers, SYNERGY_HOVER_TIP_PAD),
      global,
    };
  }

function synergyHoverNudgeFromObstacles(left, top, pW, pH, cRect, obstacles, pad) {
    let g = synergyHoverPartnerGlobal(left, top, pW, pH, cRect);
    for (let i = 0; i < 10; i++) {
      let dx = 0;
      let dy = 0;
      for (const ob of obstacles) {
        if (!synergyHoverRectsOverlap(g, ob, pad)) continue;
        const gcx = (g.left + g.right) * 0.5;
        const gcy = (g.top + g.bottom) * 0.5;
        const ocx = (ob.left + ob.right) * 0.5;
        const ocy = (ob.top + ob.bottom) * 0.5;
        dx += gcx < ocx ? -14 : 14;
        dy += gcy < ocy ? -14 : 14;
      }
      if (!dx && !dy) break;
      left += dx;
      top += dy;
      g = synergyHoverPartnerGlobal(left, top, pW, pH, cRect);
    }
    return { left, top };
  }

function synergyHoverPickPartnerPos(sRect, cRect, pW, pH, _source, popovers, containerW) {
    const bounds = synergyHoverBoundRects();
    const slots = synergyHoverPartnerSlots(sRect, cRect, pW, pH);
    const evalSlot = (slot) => synergyHoverEvaluateSlot(slot, cRect, pW, pH, bounds, popovers, containerW);
    const ok = (e) => e.inBounds && !e.hitsPopover;
    const pick = (e) => ({ left: e.left, top: e.top });

    const above = evalSlot(slots.above);
    if (ok(above)) return pick(above);

    if (above.hitsPopover) {
      const below = evalSlot(slots.below);
      if (ok(below)) return pick(below);
    }

    if (!above.inBounds) {
      for (const id of ["left", "right"]) {
        const side = evalSlot(slots[id]);
        if (ok(side)) return pick(side);
      }
    }

    if (above.hitsPopover) {
      for (const id of ["left", "right"]) {
        const side = evalSlot(slots[id]);
        if (ok(side)) return pick(side);
      }
      const below = evalSlot(slots.below);
      if (!below.hitsPopover) {
        return synergyHoverNudgeFromObstacles(
          below.left, below.top, pW, pH, cRect, popovers, SYNERGY_HOVER_TIP_PAD);
      }
    }

    let best = null;
    let bestScore = -Infinity;
    const scx = sRect.left + sRect.width * 0.5;
    const scy = sRect.top + sRect.height * 0.5;
    for (const slot of Object.values(slots)) {
      const e = evalSlot(slot);
      let score = -e.rank * 100;
      if (!e.hitsPopover) score += 1000;
      if (e.inBounds) score += 1000;
      const pcx = e.global.left + pW * 0.5;
      const pcy = e.global.top + pH * 0.5;
      score -= Math.hypot(pcx - scx, pcy - scy) * 0.05;
      if (score > bestScore) {
        bestScore = score;
        best = e;
      }
    }
    if (!best) return pick(evalSlot(slots.above));
    if (best.hitsPopover) {
      return synergyHoverNudgeFromObstacles(
        best.left, best.top, pW, pH, cRect, popovers, SYNERGY_HOVER_TIP_PAD);
    }
    return pick(best);
  }

function synergyHoverPartnerHTML(partnerId, ctx, requiresLocked) {
    const ps = SPELLS[partnerId];
    if (!ps) return "";
    const { loadout, committed } = ctx || {};
    const unlocked = requiresLocked
      ? synergySpellLockedIn(loadout, committed, partnerId)
      : synergySpellUnlocked(loadout, partnerId);
    return `<div class="synergy-hover-partner${unlocked ? " unlocked" : " locked-partner"}">
      <span class="synergy-hover-partner-icon" style="background:${ps.color}33;border:1px solid ${ps.color}">${spellIconInner(partnerId)}</span>
      <span class="synergy-hover-partner-name">${escapeHtml(ps.name)}</span>
    </div>`;
  }

function clearSynergyHoverPreview(root) {
    if (!root) return;
    const active = root._activeSynergyHover;
    if (active?.source) active.source.classList.remove("synergy-hover-active");
    if (active?.hostEl) active.hostEl.classList.remove("synergy-hover-host");
    root.querySelectorAll(".synergy-hover-preview").forEach(el => el.remove());
    root._activeSynergyHover = null;
  }

function drawSynergyHoverEdge(svg, fromRect, toRect, originRect, animate) {
    const ns = "http://www.w3.org/2000/svg";
    const toCx = toRect.left - originRect.left + toRect.width * 0.5;
    const toCy = toRect.top - originRect.top + toRect.height * 0.5;
    const fromCx = fromRect.left - originRect.left + fromRect.width * 0.5;
    const fromCy = fromRect.top - originRect.top + fromRect.height * 0.5;
    const [px, py] = skillTreeBorderAnchor(fromRect, originRect, toCx, toCy);
    const [tx, ty] = skillTreeBorderAnchor(toRect, originRect, fromCx, fromCy);
    const [c1x, c1y, c2x, c2y] = skillTreeCurveControls(px, py, tx, ty);
    const path = document.createElementNS(ns, "path");
    path.setAttribute("d", `M ${px} ${py} C ${c1x} ${c1y}, ${c2x} ${c2y}, ${tx} ${ty}`);
    path.setAttribute("class", "skill-tree-edge edge-lit edge-anim-draw");
    path.setAttribute("fill", "none");
    const fromDot = document.createElementNS(ns, "circle");
    fromDot.setAttribute("cx", String(px));
    fromDot.setAttribute("cy", String(py));
    fromDot.setAttribute("r", "4");
    fromDot.setAttribute("class", "skill-tree-joint joint-lit");
    const toDot = document.createElementNS(ns, "circle");
    toDot.setAttribute("cx", String(tx));
    toDot.setAttribute("cy", String(ty));
    toDot.setAttribute("r", "4");
    toDot.setAttribute("class", "skill-tree-joint");
    svg.append(fromDot, path, toDot);
    if (animate && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      const len = path.getTotalLength();
      path.style.strokeDasharray = `${len}`;
      path.style.strokeDashoffset = `${len}`;
      requestAnimationFrame(() => {
        path.style.transition = `stroke-dashoffset ${SYNERGY_HOVER_EDGE_MS}ms ease-out`;
        path.style.strokeDashoffset = "0";
      });
      setTimeout(() => {
        toDot.setAttribute("class", "skill-tree-joint joint-lit joint-anim-pop");
      }, SYNERGY_HOVER_EDGE_MS * 0.72);
    } else {
      toDot.setAttribute("class", "skill-tree-joint joint-lit");
    }
  }

function layoutSynergyHoverPreview(root) {
    const active = root?._activeSynergyHover;
    if (!active) return;
    const { source, container, preview, pointer } = active;
    const partner = preview.querySelector(".synergy-hover-partner");
    const svg = preview.querySelector(".synergy-hover-lines");
    if (!partner || !svg) return;

    const cRect = container.getBoundingClientRect();
    const sRect = source.getBoundingClientRect();
    partner.style.visibility = "hidden";
    partner.style.left = "0";
    partner.style.top = "0";
    const pW = partner.offsetWidth;
    const pH = partner.offsetHeight;
    const popovers = synergyHoverDetailPopoverRects();
    const picked = synergyHoverPickPartnerPos(
      sRect, cRect, pW, pH, source, popovers, container.offsetWidth);
    const previewTop = Math.min(0, picked.top - 8);
    const partnerTop = picked.top - previewTop;
    partner.style.left = `${picked.left}px`;
    partner.style.top = `${partnerTop}px`;
    partner.style.visibility = "";

    const previewH = Math.max(
      container.offsetHeight - previewTop,
      partnerTop + pH + 16,
      sRect.bottom - cRect.top + 8 - previewTop,
    );
    preview.style.width = `${container.offsetWidth}px`;
    preview.style.height = `${previewH}px`;
    preview.style.top = `${previewTop}px`;
    svg.replaceChildren();
    svg.setAttribute("width", String(container.offsetWidth));
    svg.setAttribute("height", String(previewH));
    svg.setAttribute("viewBox", `0 0 ${container.offsetWidth} ${previewH}`);
    const animateLine = !active.lineDrawn;
    const previewRect = preview.getBoundingClientRect();
    drawSynergyHoverEdge(svg, sRect, partner.getBoundingClientRect(), previewRect, animateLine);
    if (animateLine) active.lineDrawn = true;
  }

function synergyHoverContainerFor(sourceEl, root) {
    if (sourceEl.classList.contains("shop-synergy-orb")) return root;
    return sourceEl.closest(".spell-skill-unit");
  }

function showSynergyHoverPreview(root, sourceEl, pointer) {
    if (!sourceEl?.classList?.contains("shop-synergy-orb")) return;
    const partnerId = sourceEl?.dataset?.synergyPartner;
    const ctx = root?._synergyHoverCtx;
    if (!partnerId || !ctx) return;
    const container = synergyHoverContainerFor(sourceEl, root);
    if (!container) return;
    const ptr = pointer || root._activeSynergyHover?.pointer || null;
    if (root._activeSynergyHover?.source === sourceEl) {
      if (pointer) root._activeSynergyHover.pointer = pointer;
      layoutSynergyHoverPreview(root);
      return;
    }
    clearSynergyHoverPreview(root);
    sourceEl.classList.add("synergy-hover-active");
    const requiresLocked = sourceEl.dataset.synergyPartnerLocked === "1";
    const preview = document.createElement("div");
    preview.className = "synergy-hover-preview";
    preview.innerHTML =
      `<svg class="synergy-hover-lines" aria-hidden="true"></svg>${synergyHoverPartnerHTML(partnerId, ctx, requiresLocked)}`;
    const hostEl = sourceEl.closest(".shop-spell-card") || container;
    hostEl.classList.add("synergy-hover-host");
    container.appendChild(preview);
    root._activeSynergyHover = {
      source: sourceEl, container, hostEl, preview, pointer: ptr, lineDrawn: false,
    };
    layoutSynergyHoverPreview(root);
  }

let shopPopoversPaused = false;
let shopPopoversPauseAt = { x: 0, y: 0 };

function pauseShopPopovers(clientX, clientY) {
    shopPopoversPaused = true;
    shopPopoversPauseAt = { x: clientX, y: clientY };
  }

function resumeShopPopoversIfMoved(clientX, clientY) {
    if (!shopPopoversPaused) return;
    const dx = clientX - shopPopoversPauseAt.x;
    const dy = clientY - shopPopoversPauseAt.y;
    if (dx * dx + dy * dy > 25) shopPopoversPaused = false;
  }

function shopPopoversBlocked(clientX, clientY) {
    resumeShopPopoversIfMoved(clientX, clientY);
    return shopPopoversPaused;
  }

function hideShopHoverPopovers() {
    Tip.hide();
    window.SpellPreview?.hide?.();
  }

function resetShopPopoversPause() {
    shopPopoversPaused = false;
  }

window.shopPopoversBlocked = shopPopoversBlocked;
window.resetShopPopoversPause = resetShopPopoversPause;

function partnerSpellCards(grid, partnerId) {
    if (!grid || !partnerId) return { scrollTarget: null, cards: [] };
    const cards = [];
    const ownedCard = grid.querySelector(
      `.shop-owned-list .spell-skill-unit [data-spell-id="${partnerId}"]`,
    )?.closest(".shop-spell-card");
    if (ownedCard) cards.push(ownedCard);
    const catCard = grid.querySelector(
      `.category-options .shop-spell-card[data-spell-id="${partnerId}"]`,
    );
    if (catCard && !cards.includes(catCard)) cards.push(catCard);
    return { scrollTarget: ownedCard || catCard, cards };
  }

function ensureSynergyPartnerRing(card) {
    if (!card || card.querySelector(".synergy-partner-ring")) return;
    const ring = document.createElement("div");
    ring.className = "synergy-partner-ring";
    ring.setAttribute("aria-hidden", "true");
    card.insertBefore(ring, card.firstChild);
  }

function clearSynergyPartnerHighlight(grid, opts) {
    if (!grid) return;
    grid.querySelectorAll(".shop-spell-card.synergy-partner-highlight").forEach(card => {
      card.classList.remove("synergy-partner-highlight", "synergy-partner-pulse");
      card.querySelector(".synergy-partner-ring")?.remove();
    });
    grid._highlightedPartner = null;
    grid._highlightedPartnerRing = false;
    if (!opts?.keepPin) grid._pinnedPartnerId = null;
  }

function setSynergyPartnerHighlight(grid, partnerId, opts) {
    if (!grid || !partnerId) return;
    const force = !!opts?.force;
    const withRing = !!opts?.withRing;
    if (!force && grid._highlightedPartner === partnerId && grid._highlightedPartnerRing === withRing) {
      return;
    }
    clearSynergyPartnerHighlight(grid, { keepPin: !!grid._pinnedPartnerId });
    const { cards } = partnerSpellCards(grid, partnerId);
    if (!cards.length) return;
    for (const card of cards) {
      if (withRing) ensureSynergyPartnerRing(card);
      else card.querySelector(".synergy-partner-ring")?.remove();
      card.classList.add("synergy-partner-highlight");
    }
    grid._highlightedPartner = partnerId;
    grid._highlightedPartnerRing = withRing;
  }

function pulseSynergyPartnerCards(cards) {
    if (!cards?.length) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    for (const card of cards) {
      card.classList.remove("synergy-partner-pulse");
    }
    void cards[0].offsetWidth;
    for (const card of cards) {
      card.classList.add("synergy-partner-pulse");
    }
    setTimeout(() => {
      for (const card of cards) card.classList.remove("synergy-partner-pulse");
    }, SYNERGY_PARTNER_PIN_MS);
  }

function scrollToSynergyPartner(grid, partnerId) {
    const { scrollTarget, cards } = partnerSpellCards(grid, partnerId);
    if (!scrollTarget) return;
    const scroll = grid.closest(".shop-scroll");
    if (scroll) {
      const sRect = scroll.getBoundingClientRect();
      const cRect = scrollTarget.getBoundingClientRect();
      const top = scroll.scrollTop + (cRect.top - sRect.top) - (sRect.height - cRect.height) / 2;
      scroll.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    } else {
      scrollTarget.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    }
    setSynergyPartnerHighlight(grid, partnerId, { force: true, withRing: true });
    pulseSynergyPartnerCards(cards);
  }

const LOCKED_SYNERGY_PARTNER_SEL =
  ".passive-node.synergy[data-synergy-partner-blocked]:not(.owned)";

const SYNERGY_PARTNER_PIN_MS = 550 * 3 + 80;

function releaseSynergyPartnerPin(grid) {
  if (!grid || !grid._pinnedPartnerId) return;
  grid._pinnedPartnerId = null;
  clearSynergyPartnerHighlight(grid);
  const hit = grid._synergyHoverTarget;
  if (hit?.kind === "locked" && !skipSynergyPartnerHover(grid, hit.lockedSyn)) {
    const partnerId = hit.lockedSyn.dataset.synergyPartner;
    if (partnerId) setSynergyPartnerHighlight(grid, partnerId);
  }
}

function scheduleSynergyPartnerPinRelease(grid, partnerId) {
  if (!grid) return;
  clearTimeout(grid._synergyPartnerPinReleaseTO);
  const ms = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ? 400
    : SYNERGY_PARTNER_PIN_MS;
  grid._synergyPartnerPinReleaseTO = setTimeout(() => {
    if (grid._pinnedPartnerId !== partnerId) return;
    releaseSynergyPartnerPin(grid);
  }, ms);
}

function synergyHostSpellId(el) {
  const unit = el?.closest?.(".spell-skill-unit");
  const fromCard = unit?.querySelector("[data-spell-id]")?.getAttribute("data-spell-id");
  if (fromCard) return fromCard;
  return el?.closest?.("[data-skill-tree-spell]")?.dataset?.skillTreeSpell || null;
}

function skipSynergyPartnerHover(grid, synergyNodeEl) {
  const spellId = synergyHostSpellId(synergyNodeEl);
  const passives = grid?._synergyHoverCtx?.passives;
  return !!spellId && ownedSynergyOnSpell(passives, spellId);
}

function syncSynergyPreviewAttrs(node, n, owned, synergyBlocked) {
    if (!n.synergy) return;
    if (!synergyBlocked || owned) {
      node.classList.add("passive-node-previewable");
      node.setAttribute("data-synergy-preview", n.id);
    } else {
      node.classList.remove("passive-node-previewable");
      node.removeAttribute("data-synergy-preview");
    }
  }

function resolveSynergyHoverTarget(grid, target, synergySourceSel) {
    const lockedSyn = target?.closest?.(LOCKED_SYNERGY_PARTNER_SEL);
    if (lockedSyn && grid.contains(lockedSyn)) {
      return { kind: "locked", lockedSyn };
    }
    if (target?.closest?.(".synergy-hover-preview") && grid._activeSynergyHover) {
      return { kind: "orb", source: grid._activeSynergyHover.source };
    }
    const source = target?.closest?.(synergySourceSel);
    if (source && grid.contains(source)) {
      return { kind: "orb", source };
    }
    return { kind: "none" };
  }

function synergyHoverTargetEq(a, b) {
    if (!a || !b || a.kind !== b.kind) return false;
    if (a.kind === "locked") return a.lockedSyn === b.lockedSyn;
    if (a.kind === "orb") return a.source === b.source;
    return true;
  }

function applySynergyHoverTarget(grid, hit, pointer) {
    if (hit.kind === "locked") {
      clearSynergyHoverPreview(grid);
      if (!grid._pinnedPartnerId && !skipSynergyPartnerHover(grid, hit.lockedSyn)) {
        const partnerId = hit.lockedSyn.dataset.synergyPartner;
        if (partnerId) setSynergyPartnerHighlight(grid, partnerId);
      }
      return;
    }
    if (hit.kind === "orb") {
      if (!grid._pinnedPartnerId) clearSynergyPartnerHighlight(grid);
      showSynergyHoverPreview(grid, hit.source, pointer);
      return;
    }
    clearSynergyHoverPreview(grid);
    if (!grid._pinnedPartnerId) clearSynergyPartnerHighlight(grid);
  }

function wireSynergyPartnerHoverGrid(grid) {
    if (!grid || grid._synergyPartnerHoverWired) return;
    grid._synergyPartnerHoverWired = true;
    const synergySourceSel = ".shop-synergy-orb[data-synergy-partner]";
    let lastLayoutAt = 0;
    grid._synergyHoverTarget = { kind: "none" };
    grid.addEventListener("click", (e) => {
      if (e.target.closest?.(".buy-btn")) return;
      const lockedSyn = e.target.closest?.(LOCKED_SYNERGY_PARTNER_SEL);
      if (!lockedSyn || !grid.contains(lockedSyn)) return;
      if (skipSynergyPartnerHover(grid, lockedSyn)) return;
      const partnerId = lockedSyn.dataset.synergyPartner;
      if (!partnerId) return;
      pauseShopPopovers(e.clientX, e.clientY);
      hideShopHoverPopovers();
      clearSynergyHoverPreview(grid);
      grid._pinnedPartnerId = partnerId;
      scrollToSynergyPartner(grid, partnerId);
      scheduleSynergyPartnerPinRelease(grid, partnerId);
      Sound.ui();
    });
    grid.addEventListener("mousemove", (e) => {
      resumeShopPopoversIfMoved(e.clientX, e.clientY);
      const hit = resolveSynergyHoverTarget(grid, e.target, synergySourceSel);
      if (!synergyHoverTargetEq(hit, grid._synergyHoverTarget)) {
        grid._synergyHoverTarget = hit;
        applySynergyHoverTarget(grid, hit, { x: e.clientX, y: e.clientY });
      }
      const active = grid._activeSynergyHover;
      if (!active) return;
      const onSource = e.target.closest?.(synergySourceSel) === active.source;
      const onPreview = e.target.closest?.(".synergy-hover-preview");
      if (!onSource && !onPreview) return;
      active.pointer = { x: e.clientX, y: e.clientY };
      const now = performance.now();
      if (now - lastLayoutAt < 50) return;
      lastLayoutAt = now;
      layoutSynergyHoverPreview(grid);
    });
    grid.addEventListener("mouseleave", () => {
      grid._synergyHoverTarget = { kind: "none" };
      clearSynergyHoverPreview(grid);
      if (!grid._pinnedPartnerId) clearSynergyPartnerHighlight(grid);
    });
    const scroll = grid.closest(".shop-scroll");
    if (scroll) {
      scroll.addEventListener("scroll", () => {
        if (grid._activeSynergyHover) layoutSynergyHoverPreview(grid);
      }, { passive: true });
    }
    if (typeof ResizeObserver !== "undefined") {
      const ro = new ResizeObserver(() => {
        if (grid._activeSynergyHover) layoutSynergyHoverPreview(grid);
      });
      ro.observe(grid);
      grid._synergyHoverRO = ro;
    }
  }

Game.prototype.wireSynergyPartnerHoverGrid = wireSynergyPartnerHoverGrid;

/** Point on rect border (canvas-relative) where a ray from center toward (tx, ty) exits. */
function skillTreeBorderAnchor(rect, origin, towardX, towardY) {
    const left = rect.left - origin.left;
    const top = rect.top - origin.top;
    const cx = left + rect.width * 0.5;
    const cy = top + rect.height * 0.5;
    const dx = towardX - cx;
    const dy = towardY - cy;
    if (Math.abs(dx) < 0.01 && Math.abs(dy) < 0.01) return [cx, top];
    const scaleX = dx !== 0 ? (rect.width * 0.5) / Math.abs(dx) : Infinity;
    const scaleY = dy !== 0 ? (rect.height * 0.5) / Math.abs(dy) : Infinity;
    const scale = Math.min(scaleX, scaleY);
    return [cx + dx * scale, cy + dy * scale];
  }

function skillTreeCurveControls(px, py, tx, ty) {
    const adx = Math.abs(tx - px);
    const ady = Math.abs(ty - py);
    if (ady < 1 && adx < 1) return [px, py, tx, ty];
    // Nearly vertical — keep controls between endpoints so the curve never folds back.
    if (adx < 2) {
      const dir = Math.sign(ty - py) || 1;
      const bend = Math.min(Math.max(ady * 0.38, 3), (ady - 1) * 0.5);
      if (bend < 1) return [px, (py + ty) * 0.5, tx, (py + ty) * 0.5];
      return [px, py + bend * dir, tx, ty - bend * dir];
    }
    if (ady >= adx) {
      const dir = Math.sign(ty - py) || 1;
      const bend = Math.min(Math.max(ady * 0.38, 3), (ady - 1) * 0.5);
      return [px, py + bend * dir, tx, ty - bend * dir];
    }
    const dir = Math.sign(tx - px) || 1;
    const bend = Math.min(Math.max(adx * 0.38, 3), (adx - 1) * 0.5);
    return [px + bend * dir, py, tx - bend * dir, ty];
  }

function drawSkillTreeLines(tree, wrap, svg, nodeEls, opts) {
    const justUnlockedId = opts?.justUnlockedId || null;
    const spellId = opts?.spellId || wrap.dataset.skillTreeSpell;
    wrap._skillTreeEdges = [];
    const unit = wrap.closest(".spell-skill-unit");
    const spellCard = unit?.querySelector(":scope > .spell-card") ?? null;
    const origin = (unit || wrap).getBoundingClientRect();
    if (origin.width < 2 || origin.height < 2) return;
    const ns = "http://www.w3.org/2000/svg";
    const mk = (tag, attrs) => {
      const el = document.createElementNS(ns, tag);
      for (const k in attrs) el.setAttribute(k, attrs[k]);
      return el;
    };
    svg.replaceChildren();
    if (unit) {
      const tr = wrap.getBoundingClientRect();
      svg.style.left = `${origin.left - tr.left}px`;
      svg.style.top = `${origin.top - tr.top}px`;
      svg.style.width = `${origin.width}px`;
      svg.style.height = `${origin.height}px`;
    } else {
      svg.style.left = "";
      svg.style.top = "";
      svg.style.width = "";
      svg.style.height = "";
    }
    svg.setAttribute("viewBox", `0 0 ${origin.width} ${origin.height}`);

    const dot = (cx, cy, lit) => {
      const c = mk("circle", {
        cx: String(cx),
        cy: String(cy),
        r: "4",
        class: "skill-tree-joint" + (lit ? " joint-lit" : ""),
      });
      svg.appendChild(c);
      return c;
    };

    const drawEdge = (fromRect, toRect, fromOwned, toOwned, fromKey, toKey) => {
      const animPending = justUnlockedId && toKey === justUnlockedId;
      const toCx = toRect.left - origin.left + toRect.width * 0.5;
      const toCy = toRect.top - origin.top + toRect.height * 0.5;
      const fromCx = fromRect.left - origin.left + fromRect.width * 0.5;
      const fromCy = fromRect.top - origin.top + fromRect.height * 0.5;
      const [px, py] = skillTreeBorderAnchor(fromRect, origin, toCx, toCy);
      const [tx, ty] = skillTreeBorderAnchor(toRect, origin, fromCx, fromCy);
      const [c1x, c1y, c2x, c2y] = skillTreeCurveControls(px, py, tx, ty);
      const active = toOwned && !animPending;
      let cls = "skill-tree-edge";
      if (active) cls += fromOwned ? " edge-complete" : " edge-lit";
      const path = mk("path", {
        d: `M ${px} ${py} C ${c1x} ${c1y}, ${c2x} ${c2y}, ${tx} ${ty}`,
        class: cls,
        fill: "none",
      });
      path.dataset.edgeFrom = fromKey;
      path.dataset.edgeTo = toKey;
      svg.appendChild(path);
      const fromDot = dot(px, py, fromOwned && active);
      const toDot = dot(tx, ty, active);
      wrap._skillTreeEdges.push({ path, fromDot, toDot, fromKey, toKey });
    };

    if (spellCard) {
      const sr = spellCard.getBoundingClientRect();
      for (const n of tree) {
        if ((n.requires || []).length || n.synergy) continue;
        const prior = spellId ? passiveColPrereqNode(spellId, n) : null;
        if (prior && nodeEls[prior.id]) continue;
        const node = nodeEls[n.id];
        if (!node) continue;
        const owned = node.classList.contains("owned");
        drawEdge(sr, node.getBoundingClientRect(), owned, owned, "spell", n.id);
      }
    }

    for (const n of tree) {
      if (n.synergy) continue;
      const reqs = [...(n.requires || [])];
      const prior = spellId ? passiveColPrereqNode(spellId, n) : null;
      if (prior && !reqs.includes(prior.id)) reqs.push(prior.id);
      const child = nodeEls[n.id];
      if (!child || child.classList.contains("synergy") || !reqs.length) continue;
      const cr = child.getBoundingClientRect();
      const childOwned = child.classList.contains("owned");
      for (const reqId of reqs) {
        const parent = nodeEls[reqId];
        if (!parent || parent.classList.contains("synergy")) continue;
        drawEdge(
          parent.getBoundingClientRect(),
          cr,
          parent.classList.contains("owned"),
          childOwned,
          reqId,
          n.id,
        );
      }
    }
  }

Game.prototype.buildSkillTree = function (spellId, passives, wallets, onBuy, opts) {
    const fullTree = PASSIVE_TREES[spellId];
    if (!fullTree || !fullTree.length) return null;
    const showPassives = opts?.showPassives !== false;
    const showSynergies = opts?.showSynergies !== false;
    const tree = fullTree.filter(n => (n.synergy ? showSynergies : showPassives));
    if (!tree.length) return null;
    const readOnly = !!(opts && opts.readOnly);
    const sp = wallets?.sp ?? 0;
    const pp = wallets?.pp ?? 0;
    const sy = wallets?.sy ?? 0;
    const loadout = opts?.loadout || {};
    const committed = opts?.committed || {};
    const ownedRowLayout = opts?.layout === "owned-row";
    const wrap = document.createElement("div");
    wrap.className = "skill-tree" + (readOnly ? " skill-tree-ref" : "") +
      (ownedRowLayout ? " skill-tree-owned-row" : "");
    wrap.dataset.skillTreeSpell = spellId;

    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.classList.add("skill-tree-lines");
    svg.setAttribute("aria-hidden", "true");
    wrap.appendChild(svg);

    const grid = document.createElement("div");
    grid.className = "skill-tree-grid" + (ownedRowLayout ? " skill-tree-grid-owned-row" : "");
    let maxPassiveCol = 0;
    let maxPassiveRow = 0;
    const nodeEls = {};
    for (const n of tree) {
      if (!n.synergy) {
        maxPassiveCol = Math.max(maxPassiveCol, n.col ?? 0);
        maxPassiveRow = Math.max(maxPassiveRow, n.row ?? 0);
      }
    }

    const sortNodes = (a, b) => (a.col ?? 0) - (b.col ?? 0) || (a.row ?? 0) - (b.row ?? 0);
    const passiveNodes = tree.filter(n => !n.synergy).sort(sortNodes);
    const synergyNodes = tree.filter(n => n.synergy).sort(sortNodes);
    const synergyCount = synergyNodes.length;
    const passiveOnlyCol0 = passiveNodes.length > 0 &&
      !passiveNodes.some(n => (n.col ?? 0) >= 1);
    const firstSynergyRow = maxPassiveCol + 2;
    let gridRowCount = maxPassiveCol + 1;
    if (synergyCount > 0) gridRowCount = firstSynergyRow + synergyCount - 1;
    const gridColCount = maxPassiveRow + 1;
    const synergyRowFor = {};
    if (!ownedRowLayout) {
      if (gridColCount === 1 && passiveNodes.length > 0 && synergyCount === 0) {
        grid.classList.add("skill-tree-grid-single-hcol");
      }
      grid.style.gridTemplateRows = `repeat(${gridRowCount}, auto)`;
      grid.style.gridTemplateColumns = `repeat(${gridColCount}, minmax(0, 1fr))`;
      synergyNodes
        .forEach((n, i) => { synergyRowFor[n.id] = firstSynergyRow + i; });
    }
    let passiveCol = null;
    let synergyCol = null;
    const passiveRowEls = {};
    if (ownedRowLayout) {
      passiveCol = document.createElement("div");
      passiveCol.className = "skill-tree-owned-passives" +
        (passiveOnlyCol0 && synergyCount === 0 ? " skill-tree-passives-only-col" : "");
      grid.appendChild(passiveCol);
      for (const n of passiveNodes) {
        const row = n.row ?? 0;
        if (passiveRowEls[row]) continue;
        const rowEl = document.createElement("div");
        rowEl.className = "skill-tree-owned-passive-row";
        passiveCol.appendChild(rowEl);
        passiveRowEls[row] = rowEl;
      }
      if (tree.some(n => n.synergy)) {
        synergyCol = document.createElement("div");
        synergyCol.className = "skill-tree-owned-synergies";
        grid.appendChild(synergyCol);
      }
    }
    const nodesInOrder = ownedRowLayout ? [...passiveNodes, ...synergyNodes] : tree;

    for (const n of nodesInOrder) {
      const justUnlocked = !readOnly && opts?.justUnlockedId === n.id;
      const owned = !readOnly && passiveOwned(passives, spellId, n.id);
      const prereqOk = readOnly || passivePrereqsMet(passives, spellId, n);
      const synergyBlocked = !readOnly && n.synergy && n.requiresSpell &&
        !synergyPartnerMet(loadout, committed, n);
      const synergyExclusive = !readOnly && synergyExclusiveBlocked(passives, spellId, n);
      const locked = !readOnly && !owned && (!prereqOk || synergyBlocked || synergyExclusive);
      const node = document.createElement("div");
      node.className = "passive-node" + (n.synergy ? " synergy" : "") + (readOnly ? " ref" : "") +
        (owned ? " owned" : "") + (justUnlocked ? " just-unlocked" : "") +
        (owned && !justUnlocked ? " owned-reveal" : "") + (locked ? " locked" : "");
      node.dataset.passiveId = n.id;
      if (n.synergy && n.requiresSpell) node.dataset.synergyPartner = n.requiresSpell;
      if (n.synergy && n.requiresSpellLocked) node.dataset.synergyPartnerLocked = "1";
      if (synergyBlocked && !owned && !synergyExclusive) node.dataset.synergyPartnerBlocked = "1";
      node.setAttribute("data-tip-kind", "passive");
      node.setAttribute("data-tip-spell", spellId);
      node.setAttribute("data-tip-id", n.id);
      if (n.synergy) syncSynergyPreviewAttrs(node, n, owned, synergyBlocked);
      if (!ownedRowLayout) {
        if (n.synergy) {
          node.style.gridRow = String(synergyRowFor[n.id]);
          node.style.gridColumn = "1 / -1";
        } else {
          node.style.gridRow = String((n.col ?? 0) + 1);
          node.style.gridColumn = String((n.row ?? 0) + 1);
        }
      }
      const orbContent = n.synergy ? synergyOrbInner(n.id, n.name) : "";
      node.innerHTML = `
        <div class="passive-node-top">
          <div class="passive-node-orb" aria-hidden="true">${orbContent}</div>
          <div class="passive-node-text">${passiveNodeTextHTML(n, loadout, committed, synergyBlocked, ownedRowLayout)}</div>
        </div>`;
      if (readOnly) {
        const cost = document.createElement("span");
        cost.className = "buy-btn sb-ref-cost";
        cost.textContent = passiveBuyLabel(n);
        node.appendChild(cost);
      } else if (!(owned && ownedRowLayout)) {
        const btn = document.createElement("button");
        btn.className = "buy-btn";
        const buyCost = passiveBuyCost(n);
        const canAfford = n.synergy ? sy >= buyCost : pp >= buyCost;
        if (owned) {
          btn.textContent = "OWNED";
          btn.classList.add("maxed");
          btn.disabled = true;
        } else if (synergyBlocked || synergyExclusive || locked) {
          btn.textContent = synergyExclusive ? synergyExclusiveLabel(passives, spellId, n) : "LOCKED";
          btn.disabled = true;
        } else {
          btn.textContent = passiveBuyLabel(n);
          btn.disabled = !canAfford;
          if (btn.disabled) node.classList.add("unaffordable");
          btn.onclick = () => onBuy("passive", n.id);
        }
        node.appendChild(btn);
      }
      nodeEls[n.id] = node;
      if (ownedRowLayout) {
        if (n.synergy) synergyCol.appendChild(node);
        else (passiveRowEls[n.row ?? 0] || passiveCol).appendChild(node);
      } else {
        grid.appendChild(node);
      }
    }
    wrap.appendChild(grid);

    const justUnlockedId = opts?.justUnlockedId || null;
    const redraw = () => drawSkillTreeLines(tree, wrap, svg, nodeEls, {
      justUnlockedId: wrap._skillTreeAnimatingPassive || null,
      spellId,
    });
    wrap._skillTreeRedraw = redraw;
    const draw = () => {
      drawSkillTreeLines(tree, wrap, svg, nodeEls, { justUnlockedId, spellId });
      enqueuePassiveUnlocks(wrap, justUnlockedId);
    };
    requestAnimationFrame(() => requestAnimationFrame(draw));
    if (typeof ResizeObserver !== "undefined") {
      const ro = new ResizeObserver(() => {
        if (wrap._skillTreeAnimating) return;
        redraw();
      });
      ro.observe(wrap.closest(".spell-skill-unit") || wrap);
      wrap._skillTreeRO = ro;
    }
    return wrap;
  }

Game.prototype.wireShopTabs = function () {
    const tabSpells = document.getElementById("tabUpgrades");
    const tabItems = document.getElementById("tabItems");
    const tabReport = document.getElementById("tabReport");
    const spellsPanel = document.getElementById("shopSpellsPanel");
    const itemsPanel = document.getElementById("shopItemsPanel");
    const report = document.getElementById("shopReport");
    if (!tabSpells || !tabItems || !tabReport || !spellsPanel || !itemsPanel || !report) return;
    if (!this._shopTab) this._shopTab = "spells";
    const show = (which) => {
      this._shopTab = which;
      tabSpells.classList.toggle("active", which === "spells");
      tabItems.classList.toggle("active", which === "items");
      tabReport.classList.toggle("active", which === "report");
      spellsPanel.classList.toggle("hidden", which !== "spells");
      itemsPanel.classList.toggle("hidden", which !== "items");
      report.classList.toggle("hidden", which !== "report");
    };
    tabSpells.onclick = () => { show("spells"); Sound.ui(); };
    tabItems.onclick = () => { show("items"); Sound.ui(); };
    tabReport.onclick = () => { show("report"); Sound.ui(); };
    show(this._shopTab);
  }

Game.prototype.getReport = function () { return this.shopReport; }

Game.prototype.renderCombatReport = function () {
    const el = document.getElementById("shopReport");
    if (!el) return;
    el.innerHTML = this.combatReportHTML(this.getReport(), this.reportScope, true);
    el.querySelectorAll(".cr-tab").forEach(btn =>
      btn.onclick = () => { this.reportScope = btn.dataset.scope; this.renderCombatReport(); Sound.ui(); });
  }

Game.prototype.combatReportHTML = function (report, scope, showToggle, collapseDetails) {
    if (!report || !report[scope]) return `<div class="cr-empty">No combat data yet.</div>`;
    const st = report[scope];
    const names = report.names || {}, colors = report.colors || {};
    const robeFor = (key) => { const ci = colors[key]; const r = (ci != null) && ROBES[ci % ROBES.length]; return r ? r.robe : "#8a86a6"; };
    const srcLabel = (key) => key === "void" ? "The Void" : key === "self" ? "Self" : (names[key] || ("Player " + key));
    const srcColor = (key) => key === "void" ? "#6b6690" : key === "self" ? "#ff5d5d" : robeFor(key);
    const sw = (color) => `<span class="cr-sw" style="background:${color}"></span>`;
    const bar = (label, color, value, max, sub) => {
      const pct = max > 0 ? Math.max(3, Math.round(100 * value / max)) : 0;
      return `<div class="cr-row"><div class="cr-name">${label}</div>` +
        `<div class="cr-track"><div class="cr-fill" style="width:${pct}%;background:${color}"></div></div>` +
        `<div class="cr-num">${Math.round(value)}</div></div>${sub || ""}`;
    };
    const list = (rows, fn, empty) => rows.length ? rows.map(fn).join("") : `<div class="cr-empty">${empty}</div>`;

    const toggle = showToggle ? `<div class="cr-scope">` +
      `<button class="cr-tab ${scope === "round" ? "active" : ""}" data-scope="round">This round</button>` +
      `<button class="cr-tab ${scope === "match" ? "active" : ""}" data-scope="match">Whole match</button></div>` : "";

    const summary = `<div class="cr-summary">` +
      `<div class="cr-stat"><b>${st.ko || 0}</b><span>Kills</span></div>` +
      `<div class="cr-stat"><b>${st.de || 0}</b><span>Deaths</span></div>` +
      `<div class="cr-stat"><b>${Math.round(st.dd || 0)}</b><span>Dmg dealt</span></div>` +
      `<div class="cr-stat"><b>${Math.round(st.dt || 0)}</b><span>Dmg taken</span></div>` +
      `<div class="cr-stat"><b>${Math.round(st.hl || 0)}</b><span>Healing</span></div></div>`;

    const spellRows = Object.entries(st.bySpell || {}).filter(([, v]) => v > 0).sort((a, b) => b[1] - a[1]);
    const spellMax = spellRows.reduce((m, [, v]) => Math.max(m, v), 0);
    const spellHTML = list(spellRows, ([id, v]) => {
      const s = spellInfo(id);
      return bar(s ? spellLabelHTML(id) : escapeHtml(id), s ? s.color : "#8a86a6", v, spellMax);
    }, "No damage dealt yet.");

    const oppRows = Object.entries(st.toOpp || {}).filter(([, v]) => v > 0).sort((a, b) => b[1] - a[1]);
    const oppMax = oppRows.reduce((m, [, v]) => Math.max(m, v), 0);
    const oppHTML = list(oppRows, ([k, v]) =>
      bar(sw(robeFor(k)) + escapeHtml(names[k] || ("Player " + k)), robeFor(k), v, oppMax), "No damage on opponents yet.");

    const srcRows = Object.entries(st.fromSrc || {}).map(([k, spells]) =>
      [k, Object.values(spells).reduce((a, b) => a + b, 0), spells]).filter(([, t]) => t > 0).sort((a, b) => b[1] - a[1]);
    const srcMax = srcRows.reduce((m, [, t]) => Math.max(m, t), 0);
    const takenHTML = list(srcRows, ([k, total, spells]) => {
      const subRows = Object.entries(spells).filter(([sid, v]) => v > 0 && sid).sort((a, b) => b[1] - a[1]);
      const sub = subRows.length ? `<div class="cr-sub">` + subRows.map(([sid, v]) => {
        const s = spellInfo(sid);
        return `<span>${s ? spellLabelHTML(sid) : escapeHtml(sid)}: ${Math.round(v)}</span>`;
      }).join("") + `</div>` : "";
      return bar(sw(srcColor(k)) + escapeHtml(srcLabel(k)), srcColor(k), total, srcMax, sub);
    }, "No damage taken yet.");

    const healLabels = { lifesteal: "🩸 Lifesteal", drain: "🩸 Drain", regen: "✚ Regen" };
    const healRows = Object.entries(st.healBy || {}).filter(([, v]) => v > 0).sort((a, b) => b[1] - a[1]);
    const healMax = healRows.reduce((m, [, v]) => Math.max(m, v), 0);
    const healHTML = list(healRows, ([k, v]) => bar(escapeHtml(healLabels[k] || k), "#5fd38a", v, healMax), "No healing yet.");

    const section = (title, body) => `<div class="cr-section"><div class="cr-title">${title}</div>${body}</div>`;
    const details = section("Damage by spell", spellHTML) +
      section("Damage dealt to", oppHTML) +
      section("Damage taken from", takenHTML) +
      section("Healing by source", healHTML);
    if (collapseDetails) {
      return toggle + summary +
        `<details class="mo-cr-details"><summary class="mo-cr-details-toggle">Show detailed summary</summary>` +
        `<div class="mo-cr-details-body">${details}</div></details>`;
    }
    return toggle + summary + details;
  }
